import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import { groupsAPI } from '../../services/api';

interface GroupStatusChangeDialogProps {
  open: boolean;
  onClose: () => void;
  group: any;
  onStatusChanged: () => void;
}

const GroupStatusChangeDialog: React.FC<GroupStatusChangeDialogProps> = ({
  open,
  onClose,
  group,
  onStatusChanged,
}) => {
  const [loading, setLoading] = useState(false);

  const handleStatusChange = async (newStatus: number) => {
    if (!group) return;
    setLoading(true);
    try {
      await groupsAPI.updateGroupStatus(group.id, newStatus);
      toast.success(`Group status updated to ${newStatus === 1 ? 'Active' : 'Inactive'}`);
      onStatusChanged();
      onClose();
    } catch (error: any) {
      toast.error('Failed to update group status');
    } finally {
      setLoading(false);
    }
  };

  const groupName = group?.name || 'Group';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Confirm Status Change</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to change the status for this group?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Group: <strong>{groupName}</strong>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => handleStatusChange(group?.status === 1 ? 0 : 1)}
          disabled={loading}
          variant="contained"
          color={group?.status === 1 ? 'error' : 'success'}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupStatusChangeDialog;